// extracted by mini-css-extract-plugin
export var danger = "_32-6";
export var lightPink = "_32-a";
export var medium = "_32-j";
export var nearSquare = "_32-m";
export var neutralBlue = "_32-8";
export var neutralYellow = "_32-7";
export var noCapitalize = "_32-1";
export var normal = "_32-2";
export var pill = "_32-0";
export var primary = "_32-3";
export var primaryLight = "_32-4";
export var shadow = "_32-n";
export var small = "_32-k";
export var solidBlack = "_32-i";
export var solidGreen = "_32-d";
export var solidLightBlue = "_32-f";
export var solidNavy = "_32-e";
export var solidOrange = "_32-h";
export var solidPink = "_32-g";
export var solidRed = "_32-b";
export var solidWhite = "_32-9";
export var solidYellow = "_32-c";
export var success = "_32-5";
export var xsmall = "_32-l";